import { useState } from 'react';
/**
 * Hook for using sessionStorage like a useState hook
 *
 * @param {string} key The key for the sessionStorage value
 * @param {T} [defaultValue] Optional default/fallback value if sessionStorage item doesn't exist
 * @returns {T}
 * @example
 * const hero = useReadSessionStorage('hero', 'Batman');
 */
export var useReadSessionStorage = function (key, defaultValue) {
    var value = useState(function () {
        try {
            var savedValue = JSON.parse(globalThis.sessionStorage.getItem(key));
            if (savedValue)
                return savedValue;
        }
        catch (_a) {
            // Plain strings that cannot be parsed into JSON will throw an exception. Catch it here and check the raw value
            var savedValue = globalThis.sessionStorage.getItem(key);
            if (savedValue)
                return savedValue;
        }
        if (defaultValue instanceof Function)
            return defaultValue();
        return defaultValue;
    })[0];
    return value;
};
